import React from 'react';

import { Banner, Text } from '@betterment/samba-react';

export const UnderweightWarning: React.FC = () => {
  return (
    <Banner variant="warning">
      <Banner.Content>
        <Text>
          You’re selling a position to a degree that may cause it to become underweight in your client’s portfolio
          strategy. As a result, <strong>Betterment’s rebalancing algorithm may attempt to buy it back,</strong> which
          could result in a wash sale, or purchase substitute securities where applicable. To avoid this, consider
          adjusting your client’s portfolio strategy instead.
        </Text>
      </Banner.Content>
    </Banner>
  );
};
